if (!window.slidersInitialized) {
    document.querySelectorAll('.slider-section .swiper').forEach((slider) => {
        new Swiper(slider, {
            allowTouchMove: true,
            spaceBetween: 0,
            centeredSlides: false,
            slidesPerView: 1,
            speed: 800,
            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                961: {
                    allowTouchMove: false,
                },
            },
            on: {
                init: function (swiper) {
                    let parent = swiper.el.closest('.slider-section');
                    parent
                        .querySelector('.mobile-indexes span:first-child')
                        .classList.add('current');
                },
                slideChange: function (swiper) {
                    let parent = swiper.el.closest('.slider-section');
                    let index = swiper.realIndex + 1;

                    parent
                        .querySelectorAll('.mobile-indexes span')
                        .forEach((span) => {
                            span.classList.remove('current');
                        });

                    parent
                        .querySelector(
                            '.mobile-indexes span:nth-child(' + index + ')'
                        )
                        .classList.add('current');
                },
            },
        });
    });

    window.slidersInitialized = true;
}
